var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fish") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fish",
    "data-name": "fish"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.731,55.147a3.223,3.223,0,0,0,3.219-3.219V42.564a3.223,3.223,0,0,0-3.219-3.219H36.477C34.9,38.2,29.189,33.6,31.217,28.064c1.377-3.754,5.535-5.91,8.339-5.327,3.069.637,3.326,4.221,3.205,6.3a1.75,1.75,0,0,0,3.494.2c.311-5.376-1.927-9.089-5.987-9.932-4.823-1-10.469,2.456-12.336,7.549-1.943,5.3.688,9.7,3.275,12.486H14.269a3.223,3.223,0,0,0-3.219,3.219v9.364a3.223,3.223,0,0,0,3.219,3.219h3.192V93.058H14.269a3.222,3.222,0,0,0-3.219,3.218v9.365a3.222,3.222,0,0,0,3.219,3.218h99.462a3.222,3.222,0,0,0,3.219-3.218V96.276a3.222,3.222,0,0,0-3.219-3.218h-3.192V55.147ZM14.55,42.845h98.9v8.8H14.55Zm98.9,62.514H14.55v-8.8h98.9Zm-6.411-12.3H20.961V55.147h86.078Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.105,87.071c8.186,0,15.6-2.6,19.352-6.793a.761.761,0,0,1,.964-.155l8.893,5.286a3.329,3.329,0,0,0,5.029-2.862v-16.8a3.329,3.329,0,0,0-5.029-2.861l-8.893,5.285a.763.763,0,0,1-.964-.154c-3.751-4.191-11.166-6.794-19.352-6.794-12.276,0-21.892,5.678-21.892,12.925S46.829,87.071,59.105,87.071Zm0-22.351c7.112,0,13.684,2.209,16.745,5.628a4.275,4.275,0,0,0,5.358.829l8.635-5.131v16.2l-8.634-5.131a4.278,4.278,0,0,0-5.359.829c-3.061,3.418-9.633,5.627-16.745,5.627-9.969,0-18.392-4.316-18.392-9.426S49.136,64.72,59.105,64.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1,73.6a1.75,1.75,0,1,0-1.75-1.75A1.75,1.75,0,0,0,49.1,73.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/fish.396949a2636a25f7cb444007deead0ac.svg";
export { ForwardRef as ReactComponent };